import React, { FC } from 'react'
import calendarPreview from '../../assets/img/calendar-preview.png'

import './WelcomeContent.scss'

// type WeclomeContentProps = {}
const WelcomeContent: FC = () => {
  return (
    <div className='welcome-content'>
      <div className='welcome-content__logo'>
        <div className='welcome-content__logo__image' />
      </div>
      <div className='welcome-content__text-wrapper'>
        <div className='welcome-content__text-wrapper__title'>Discover Attention Nest</div>
        <div className='welcome-content__text-wrapper__trust'>
        the preferred social media management platform for social media specialists around the world.
          {/* <span>6500+</span> brands trust Attention Nest with their content */}
        </div>
      </div>
      <div className='welcome-content__preview'>
        <div>
          <img alt='DEBUG' src={calendarPreview} />
        </div>
      </div>
    </div>
  )
}

export default WelcomeContent
